import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setAlert } from "../../action/alert";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import "./notification.css";
import SendNotification from "./sendNotification";
import { cancelNotificationTask, createNotificationTask, getNotificationTask, searchNotifications, searchNotificationsByUserId } from "../../action/notification";
import FindNotification from "./findNotification";
import { Box, Dialog, DialogContent, DialogTitle, useTheme } from "@mui/material";
import { getNotificationPermission, notificationStatusMoreHeaders } from "./notificationConstant";
import { getFormatedJSON } from "../../utils/general";

const activeTabSx = { border: '1px solid #bdbdbd', backgroundColor: 'gray', color: '#333333', textTransform: 'capitalize' };
const nonActiveTabSx = { border: 'none', backgroundColor: 'none', color: '#333333', textTransform: 'capitalize' };
const dialogSx = (theme) => ({
  zIndex: "2400 !important",
  "& .MuiDialogTitle-root": { backgroundColor: "#f4f4f4", "& h2": { fontSize: "16px !important" } },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
    minWidth: "800px",
    maxWidth: "800px",
    [theme.breakpoints.down('sm')]: { minWidth: 0, maxWidth: "100%", padding: theme.spacing(1.5) },
  },
  "& .buttonContainer": { display: "flex", justifyContent: "flex-end", marginTop: "16px" },
  "& .MuiDialog-paperWidthSm": {
    maxWidth: "800px",
    [theme.breakpoints.down('sm')]: { maxWidth: "100%", margin: theme.spacing(1) },
  },
  "& .dialogContents": {
    maxWidth: "800px",
    minHeight: "280px",
    maxHeight: "240px",
    overflowY: "auto",
    [theme.breakpoints.down('sm')]: { maxWidth: "100%", maxHeight: "50vh" },
  },
});

const headers = {
    productSerialNumber: "Product Serial Number",
    status: "QR Code Print Status",
    reasonOfFailure: "Reason of Failure"
};

const NotificationManagement = ({
    wrapperClass,
    allowedDeviceCategories,
    allowedCompanyBrand,
    allowedCountries,
    setAlert,
    notificationStore,
    getNotificationTask,
    createNotificationTask,
    cancelNotificationTask,
    searchNotificationsByUserId,
    searchNotifications,
    userData,
    tenantData,
    userRoles,
    userLevel,
}) => {
    const theme = useTheme();
    const [activeTab, setActiveTab] = React.useState(0)
    const [dialog, setDialog] = useState(false);
    const [dialogTab, setDialogTab] = useState(0);
    const [dialogContents, setDialogContents] = useState({ title: "", data: {}, content: "" })

    const tabs = [{ label: "Send Notification", permission: 'sendNotification' }, { label: "Search Notification", permission: 'getNotificationTask' }]
    const [availableTabs, setAvailableTabs] = React.useState([]);
    const [selectedTab, setSelectedTab] = React.useState(availableTabs[0]);

    useEffect(() => {
        const visibleTabs = tabs?.filter(t => {
            return getNotificationPermission(userRoles, t?.permission)
        })?.map(t => t?.label)
        setAvailableTabs(visibleTabs)
        setSelectedTab(visibleTabs[0])
    }, [userRoles])

    return (
        <ResponsiveContentWrapper className={wrapperClass || ""}>
            {(!getNotificationPermission(userRoles, 'sendNotification') && !(getNotificationPermission(userRoles, 'getNotificationTask') || getNotificationPermission(userRoles, 'getNotificationList'))) ? <div>
                <h2>Insufficient Permission</h2>
            </div>
                :
                <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0, marginTop: 0, boxSizing: "border-box" }}>
                    <Tabs
                        value={activeTab}
                        onChange={(e, newValue) => {
                            setActiveTab(newValue)
                            setSelectedTab(availableTabs[newValue])
                        }}
                        variant="scrollable"
                        scrollButtons="auto"
                        TabIndicatorProps={{
                            style: {
                                backgroundColor: "#bdbdbd"
                            }
                        }}
                        style={{ marginTop: 0 }}
                        sx={{
                            "& .MuiTab-root": { minWidth: "auto", px: 2, color: "#333333" },
                            "& .MuiTab-root.Mui-selected": { color: "#333333" }
                        }}
                    >
                        {availableTabs?.map((t) => <Tab key={t} label={t} sx={selectedTab === t ? activeTabSx : nonActiveTabSx} />)}
                    </Tabs>
                    {
                        selectedTab === "Send Notification" ?
                            <SendNotification
                                allowedDeviceCategories={allowedDeviceCategories}
                                allowedCompanyBrand={allowedCompanyBrand}
                                allowedCountries={allowedCountries}
                                setAlert={setAlert}
                                notificationStore={notificationStore}
                                createNotificationTask={createNotificationTask}
                                getNotificationTask={getNotificationTask}
                                setDialog={setDialog}
                                setDialogContents={setDialogContents}
                                setDialogTab={setDialogTab}
                                userLevel={userLevel}
                            ></SendNotification>
                            :
                            <FindNotification
                                notificationData={notificationStore}
                                getNotificationTask={getNotificationTask}
                                searchNotificationsByUserId={searchNotificationsByUserId}
                                allowedCountries={allowedCountries}
                                searchNotifications={searchNotifications}
                                userData={userData}
                                tenantData={tenantData}
                                setDialog={setDialog}
                                setDialogContents={setDialogContents}
                                setDialogTab={setDialogTab}
                                userRoles={userRoles}
                            ></FindNotification>
                    }
                </Box>}
            <Dialog
                sx={dialogSx(theme)}
                open={dialog}
                TransitionProps={{ timeout: 300 }}
                slotProps={{ backdrop: { TransitionProps: { timeout: 300 } } }}
            >
                <DialogTitle >
                    {dialogContents?.title}
                </DialogTitle>
                <DialogContent>
                    {
                        dialogContents?.content?.toLowerCase()?.includes("notificationdetails") ?
                            <>
                                <Tabs
                                    value={dialogTab}
                                    onChange={(e, newValue) => {
                                        setDialogTab(newValue)
                                    }}
                                    TabIndicatorProps={{
                                        style: {
                                            backgroundColor: "#bdbdbd"
                                        }
                                    }}
                                    sx={{
                                        "& .MuiTab-root": { color: "#333333" },
                                        "& .MuiTab-root.Mui-selected": { color: "#333333" }
                                    }}
                                >
                                    <Tab label="Details" sx={dialogTab == 0 ? activeTabSx : nonActiveTabSx} />
                                    <Tab label="JSON" sx={dialogTab == 1 ? activeTabSx : nonActiveTabSx} />
                                </Tabs>
                                <Box >
                                    {
                                        dialogTab === 0 ?
                                            <Box className="dialogContents">
                                                {dialogContents?.data && dialogContents?.content !== "userNotificationDetails" && <table
                                                    width="100%"
                                                    align="center"
                                                    className="table style-4 mb-20 notificationDataTable"
                                                >
                                                    <thead
                                                        style={{ position: "sticky", top: 0, zIndex: 50, background: "white" }}
                                                    >
                                                        <tr>
                                                            {Object.keys(notificationStatusMoreHeaders).map((key) => (
                                                                <th key={key}>{notificationStatusMoreHeaders[key]?.label}</th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr style={{ background: "white" }}>
                                                            {
                                                                Object.keys(notificationStatusMoreHeaders).map((key) => {
                                                                    return (
                                                                        <td key={key}
                                                                            className={
                                                                                String(dialogContents?.data[key]).length > 200
                                                                                    ? "breakWord"
                                                                                    : ""
                                                                            }
                                                                        >
                                                                            {dialogContents?.data?.hasOwnProperty(key) ? dialogContents?.data[key] : "-"}
                                                                        </td>
                                                                    );
                                                                })}
                                                        </tr>

                                                    </tbody>
                                                </table>
                                                }
                                                {dialogContents?.data && (
                                                  <>
                                                    {(dialogContents.data.fullTaskId || dialogContents.data.fullUniqueId) && (
                                                      <>
                                                        <div style={{ marginTop: "8px" }} className="page-title">
                                                          <h3>{dialogContents.data.fullTaskId ? "Task ID" : "Unique ID"}</h3>
                                                        </div>
                                                        <div>
                                                          {dialogContents.data.fullTaskId || dialogContents.data.fullUniqueId}
                                                        </div>
                                                      </>
                                                    )}
                                                        <div style={{ marginTop: "8px" }} className="page-title">
                                                          <h3>Message</h3>
                                                        </div>
                                                        <Box>
                                                          {getFormatedJSON(dialogContents.data.msg)}
                                                        </Box>
                                                      </>
                                                    )}
                                            </Box>
                                            :
                                            <Box className="dialogContents">
                                                {getFormatedJSON(dialogContents?.data?.payload)}
                                            </Box>
                                    }
                                    <Box className="buttonContainer grey-theme">
                                        <button
                                            style={{ marginLeft: "8px" }}
                                            className="btn btn-style-2 dark-text gray-bg"
                                            onClick={(e) => { setDialog(false) }}
                                        >
                                            Close
                                        </button>
                                    </Box>
                                </Box></>
                            :
                            <>
                                <Box>
                                    {`Are you sure you want to cancel the notification with task ID ${dialogContents?.data?.fullTaskId} ?`}
                                </Box>
                                <Box className="buttonContainer grey-theme">
                                    <button
                                        style={{ marginLeft: "8px" }}
                                        className="btn btn-style-2 dark-text gray-bg"
                                        onClick={(e) => { setDialog(false) }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        style={{ marginLeft: "8px" }}
                                        className="btn btn-style-2 orange-bg"
                                        onClick={(e) => {
                                            setDialog(false)
                                            cancelNotificationTask(dialogContents?.data?.fullTaskId, () => {
                                                getNotificationTask(dialogContents?.data?.fullTaskId)
                                            })
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </Box></>

                    }


                </DialogContent>
            </Dialog>
        </ResponsiveContentWrapper>
    );
}

const mapStateToProps = (state) => ({
    allowedDeviceCategories: state.auth.allowedDeviceCategories,
    allowedCompanyBrand: state.auth.allowCompanyBrand,
    allowedCountries: state.auth.allowedCountries,
    userLevel: state.auth.userLevel,
    userRoles: state.auth.roles,
    notificationStore: state.notification,
    userData: state.user,
    tenantData: state?.tenant?.tenantInfo
});

const mapDispatchToProps = (dispatch) => ({
    setAlert: (message, status) => dispatch(setAlert(message, status)),
    createNotificationTask: (requestData) => dispatch(createNotificationTask(requestData)),
    getNotificationTask: (taskId, action = "updateGetNotification") => dispatch(getNotificationTask(taskId, action)),
    searchNotificationsByUserId: (userId, pgIndex, severity = null) => dispatch(searchNotificationsByUserId(userId, pgIndex, severity)),
    searchNotifications: (searchBy, searchStr, pgIndex, tenantId, token) => dispatch(searchNotifications(searchBy, searchStr, pgIndex, tenantId, token)),
    cancelNotificationTask: (taskId, cb) => dispatch(cancelNotificationTask(taskId, cb)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationManagement);